// Author Shi Wen Long
// Date 2021-10-29 11:25:47

import {getModelDeliverTerms, getModelPaymentTerms, getModelTaxRates} from "@/model/sithMes/stool/TermsAndTaxRate.js";

class SithMesStoolPrPrice {
    constructor({
                    id = null,
                    prId = '',
                    prCode = '',
                    prItem = '',
                    matCode = '',
                    vendorId = '',
                    vendor = '',
                    price = '',
                    taxRate = '',
                    moneyType = '',
                    biddingCase = '',
                    deliverItems = '',
                    payItems = '',
                    feedbackTime = '',
                    priceStatus = '',
                    returnSapDate = '',
                    expectedFeedbackDate = '',
                    supplyCycle = '',
                    periodValidity = '',
                    attachments = '',
                    remark = '',
                    attachmentsList = ''
                }
                    = {}) {
        this.id = id;
        this.prId = prId;
        this.prCode = prCode;
        this.prItem = prItem;
        this.matCode = matCode;
        this.vendorId = vendorId;
        this.vendor = vendor;
        this.price = price;
        this.taxRate = taxRate;
        this.moneyType = moneyType;
        this.biddingCase = biddingCase;
        this.deliverItems = deliverItems;
        this.payItems = payItems;
        this.feedbackTime = feedbackTime;
        this.priceStatus = priceStatus;
        this.returnSapDate = returnSapDate;
        this.expectedFeedbackDate = expectedFeedbackDate;
        this.supplyCycle = supplyCycle;
        this.periodValidity = periodValidity;
        this.attachments = attachments;
        this.remark = remark;
        this.attachmentsList = attachmentsList;
    }
}

function newEntity() {
    return new SithMesStoolPrPrice();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.id',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'prCode',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.prCode',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'prItem',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.prItem',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'matCode',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.matCode',
            sortable: true,
            form: {
                type: 'input',
                linkTo: 'material_bom',
            }
        },
        {
            key: 'bulk',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.bulk',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNameCh',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.vendorNameCh',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'vendorNameEn',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.vendorNameEn',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'vendor',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.vendor',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'shortText',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.shortText',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'descriptionZh',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.descriptionZh',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'poText',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.poText',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'itemDlvDate',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.itemDlvDate',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'deliverLocation',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.deliverLocation',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'wbsElement',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.wbsElement',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'qtyRequested',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.qtyRequested',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'qtyOrdered',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.qtyOrdered',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'creationDate',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.creationDate',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'prUnit',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.prUnit',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'qtyOpen',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.qtyOpen',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'engineer',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.engineer',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'category',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.category',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'networkNumber',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.networkNumber',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'purchaseGroup',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.purchaseGroup',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.projectCode',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'price',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.price',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'taxRate',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.taxRate',
            sortable: true,
            form: {
                type: 'select',
                options: getModelTaxRates()
            }
        },
        {
            key: 'moneyType',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.moneyType',
            sortable: true,
            form: {
                type: 'select',
                options: [
                    {
                        value: 'CNY',
                        text: '人民币/CNY'
                    },
                    {
                        value: 'EUR',
                        text: '欧元/EUR'
                    },
                    {
                        value: 'USD',
                        text: '美元/USD'
                    }
                ]
            }
        },
        {
            key: 'biddingCase',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.biddingCase',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'deliverItems',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.deliverItems',
            sortable: true,
            form: {
                type: 'select',
                options: getModelDeliverTerms()
            }
        },
        {
            key: 'payItems',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.payItems',
            sortable: true,
            form: {
                type: 'select',
                options: getModelPaymentTerms()
            }
        },
        {
            key: 'feedbackTime',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.feedbackTime',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'priceStatus',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.priceStatus',
            sortable: true,
            form: {
                type: 'select',
                options: [
                    {value: '0', text: '等待报价'},
                    {value: '1', text: '完成报价'},
                    {value: '2', text: '放弃报价'},
                    {value: '3', text: '更新报价'}
                ]
            }
        },
        {
            key: 'returnSapDate',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.returnSapDate',
            sortable: true,
            form: {
                type: 'datetimepicker'
            }
        },
        {
            key: 'expectedFeedbackDate',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.expectedFeedbackDate',
            sortable: true,
            form: {
                type: 'datetimepicker'
            }
        },
        {
            key: 'supplyCycle',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.supplyCycle',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'periodValidity',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.periodValidity',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'attachmentsList',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.attachmentsList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment'
            }
        },
        {
            key: 'prReportList',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.prReportList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.stool.sithMesStoolPrPrice.grid.remark',
            sortable: true,
            form: {
                type: 'textarea'
            }
        }
    ])
}

const filter = {
    idFilter: "",
    idListFilter: "",
    prIdFilter: "",
    prCodeFilter: "",
    prItemFilter: "",
    matCodeFilter: "",
    bulkFilter: '',
    vendorIdFilter: "",
    vendorFilter: "",
    priceFilter: "",
    taxRateFilter: "",
    moneyTypeFilter: "",
    biddingCaseFilter: "",
    deliverItemsFilter: "",
    payItemsFilter: "",
    priceStatusFilter: "",
    returnSapDateRteFilter: "",
    returnSapDateLteFilter: "",
    expectedFeedbackDateRteFilter: "",
    expectedFeedbackDateLteFilter: "",
    feedbackTimeRteFilter: "",
    feedbackTimeLteFilter: "",
    creationDateRteFilter: "",
    creationDateLteFilter: "",
    supplyCycleFilter: "",
    periodValidityFilter: "",
    isHistoryFilter: "",
    purchaseGroupFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'prCodeFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.prCode',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'prItemFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.prItem',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'matCodeFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.matCode',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'bulkFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.bulk',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorIdFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.vendorId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesStoolVendor'
            , correspondingField: 'id'
        }
    },
    {
        key: 'vendorFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.vendor',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'priceFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.price',
        disabled: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'taxRateFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.taxRate',
        disabled: false,
        form: {
            type: 'select',
            options: getModelTaxRates()
        }
    },
    {
        key: 'moneyTypeFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.moneyType',
        disabled: false,
        form: {
            type: 'select',
            options: [
                {
                    value: 'CNY',
                    text: '人民币/CNY'
                },
                {
                    value: 'EUR',
                    text: '欧元/EUR'
                },
                {
                    value: 'USD',
                    text: '美元/USD'
                }
            ]
        }
    },
    {
        key: 'biddingCaseFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.biddingCase',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'deliverItemsFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.deliverItems',
        disabled: false,
        form: {
            type: 'select',
            options: getModelDeliverTerms()
        }
    },
    {
        key: 'payItemsFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.payItems',
        disabled: false,
        form: {
            type: 'select',
            options: getModelPaymentTerms()
        }
    },
    {
        key: 'priceStatusFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.priceStatus',
        disabled: false,
        form: {
            type: 'select',
            options: [
                {value: '0', text: '等待报价'},
                {value: '1', text: '完成报价'},
                {value: '2', text: '放弃报价'},
                {value: '3', text: '更新报价'}
            ]
        }
    },
    {
        key: 'returnSapDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.returnSapDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'returnSapDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.returnSapDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'expectedFeedbackDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.expectedFeedbackDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'expectedFeedbackDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.expectedFeedbackDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'feedbackTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.feedbackTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'feedbackTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.feedbackTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'creationDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.creationDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'creationDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.creationDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'supplyCycleFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.supplyCycle',
        disabled: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'periodValidityFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.periodValidity',
        disabled: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'purchaseGroupFilter',
        label: 'label.sith.stool.sithMesStoolPrPrice.filter.purchaseGroup',
        disabled: false,
        form: {
            type: 'input'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'prId',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.prId',
        sortable: true,
        disabled: true,
        visible: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'prCode',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.prCode',
        sortable: true,
        disabled: true,
        visible: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'prItem',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.prItem',
        sortable: true,
        disabled: true,
        visible: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'matCode',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.matCode',
        sortable: true,
        disabled: true,
        visible: true,
        form: {
            type: 'input'
        }
    },
    {
        key: 'vendorId',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.vendorId',
        sortable: true,
        disabled: true,
        visible: true,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesStoolVendor'
            , correspondingField: 'id'
        }
    },
    {
        key: 'vendor',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.vendor',
        sortable: true,
        disabled: true,
        visible: true,
        form: {
            type: 'input'
        }
    },
    {
        key: 'price',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.price',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'taxRate',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.taxRate',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            options: getModelTaxRates()
        }
    },
    {
        key: 'moneyType',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.moneyType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            options: [
                {
                    value: 'CNY',
                    text: '人民币/CNY'
                },
                {
                    value: 'EUR',
                    text: '欧元/EUR'
                },
                {
                    value: 'USD',
                    text: '美元/USD'
                }
            ]
        }
    },
    {
        key: 'biddingCase',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.biddingCase',
        sortable: true,
        disabled: true,
        visible: true,
        form: {
            type: 'input'
        }
    },
    {
        key: 'deliverItems',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.deliverItems',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            options: getModelDeliverTerms()
        }
    },
    {
        key: 'payItems',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.payItems',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            options: getModelPaymentTerms()
        }
    },
    {
        key: 'feedbackTime',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.feedbackTime',
        sortable: true,
        disabled: true,
        visible: true,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'priceStatus',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.priceStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            options: [
                {value: '0', text: '等待报价'},
                {value: '1', text: '完成报价'},
                {value: '2', text: '放弃报价'},
                {value: '3', text: '更新报价'}
            ]
        }
    },
    {
        key: 'returnSapDate',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.returnSapDate',
        sortable: true,
        disabled: true,
        visible: true,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'expectedFeedbackDate',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.expectedFeedbackDate',
        sortable: true,
        visible: true,
        form: {
            type: 'datetimepicker'
        }
    },
    {
        key: 'supplyCycle',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.supplyCycle',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'periodValidity',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.periodValidity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea'
        }
    },
    {
        key: 'attachmentsList',
        label: 'label.sith.stool.sithMesStoolPrPrice.entity.attachments',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment'
            , correspondingField: 'attachments'
        }
    }
]

export {
    SithMesStoolPrPrice, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
